import _defineProperty from "/home/vsts/work/r1/a/artifacts/source-code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { util as APIServiceUtil, IUserProperties, injectAPISession, injectModelInstantiator } from '@monofe/apiservice';
import { injectMediaCacheController } from '@monofe/apiservice/util/interface';
import { media, media as streamlibMedia } from '@monofe/streamlib';
import MainView from '@monofe/ui-workspace/tour';
import { ITourType } from '@monofe/ui-workspace/tour/interface';
import mapTour from '@monofe/ui-workspace/tour/mapping/mapping';
import { changeValueByTypes, getProjectOverrides, injectENV, removeValueByKeys } from '@monofe/util';
import { useRouter } from 'next/dist/client/router';
import Head from 'next/head';
import { useCallback, useEffect, useReducer, useState } from 'react';
import mediaJSON from '../../../public/assets/media.json';
import DownloadLanguageAlertTrigger from '../../components/DownloadLanguageAlert';
import DownloadTourAlertTrigger from '../../components/DownloadTourAlert';
import container from '../../utils/container';
import getHref from '../../utils/href';
import { generateLocalizedTourLinks } from '../../utils/localization';
import { siteObjectMediaResolver } from '../../utils/media';
import getSession from '../../utils/session';
import settings from '../../utils/settings';
import { injectSiteConfig } from '../../utils/siteConfig';
import siteData from '../../utils/siteData';
import { resolverData } from '../../utils/tourDataResolver';
/* TODO: refactor & tidy use to common file */

import { _floorplans } from './[tourId]/floorplan';

function _StateReducer(state, action) {
  const newState = action(state);
  return newState;
}

const _downloadList = async (session, languageId, tourId) => {
  if (!languageId || languageId <= 0) {
    return [];
  }

  if (!tourId || tourId <= 0) {
    return [];
  }

  const database = await session.db.open();
  const language = await database.get('ILanguageDto', languageId);
  const tour = await database.get('ITourDto', tourId);
  const tourDownloadList = await session.media.mediaForLanguageWithTour(language, tour);
  const floorplans = await _floorplans(session, language, tour);
  const floorplanStyles = await Promise.all(floorplans.map(floorplan => floorplan.styleId).filter(styleId => styleId).map(styleId => session.db.get('IStyleDto', styleId)));
  /* Combine all IMediumDto.id from Floorplans & related styled */

  const mediumIds = [...floorplans.map(item => item.imageMediumId), ...floorplanStyles.flatMap(style => [style.backgroundImageMediumId, style.foregroundImageMediumId, style.menuImageMediumId])].filter(id => id);
  const floorplanDownloadList = await Promise.all(mediumIds.map(mediumId => session.db.get('IMediumDto', mediumId)));
  database.close();
  return [...tourDownloadList, ...floorplanDownloadList];
};

export const getStaticPaths = async () => {
  const workspace = await getSession();
  await workspace.db.open();
  const languages = await APIServiceUtil.languages.allLanguagesUsedInTours(workspace.db);
  const parameters = (await Promise.all(languages.map(async language => (await APIServiceUtil.tours.ToursForLanguage(workspace.db, language)).map(tour => ({
    params: {
      languageId: language.id.toString(),
      tourId: tour.id.toString()
    }
  }))))).flat();
  workspace.db.close();
  return {
    paths: parameters,
    fallback: false
  };
};
export const getStaticProps = async _ref => {
  var _media$expand;

  let {
    params
  } = _ref;

  if (!params) {
    return {
      notFound: true
    };
  }

  const languageId = params.languageId;
  const tourId = params.tourId;
  const workspace = await getSession();
  await workspace.db.open();
  const tour = await workspace.db.get('ITourDto', Number.parseInt(tourId, 10));
  const language = await workspace.db.get('ILanguageDto', Number.parseInt(languageId, 10));
  const site = await workspace.db.first('ISiteDto');
  const downloadList = await _downloadList(workspace, language.id, tour.id);
  const environment = injectENV();
  const tourData = await mapTour({
    workspace: workspace,
    tour: tour,
    language: language,
    imageMediaResolver: (mediumId, workspace) => siteObjectMediaResolver(mediumId, workspace, settings(environment), language),
    getHref: (language, tour, siteObject, database) => getHref('SiteObject', {
      language,
      tour,
      siteObject,
      db: database
    }),
    getFloorplanHref: (language, tour, database) => getHref('FloorPlan', {
      language,
      tour,
      db: database
    }),
    getLanguageSelectHref: database => getHref('LanguageSelect', {
      db: database
    }),
    getTourSelectHref: (language, database) => getHref('TourSelect', {
      language,
      db: database
    })
  });

  const model = _objectSpread({}, tourData[0]);

  const localizedHeadData = await generateLocalizedTourLinks(workspace, tour);
  workspace.db.close();
  /* Data contains the APIService Model which is not needed at runtime, strip to help performance */

  removeValueByKeys(model, 'data');
  /* Get the MediaJSON & include everything except index.$LANGCODE.html where LANGCODE!==language.name */

  const propertiesMediaJSON = (_media$expand = media.expand(JSON.stringify(mediaJSON))) !== null && _media$expand !== void 0 ? _media$expand : media.create();
  propertiesMediaJSON.media = propertiesMediaJSON.media.map(medium => _objectSpread(_objectSpread({}, medium), {}, {
    versions: medium.versions.filter(version => {
      const isHTML = version.path.endsWith('.html');

      if (!isHTML) {
        return true;
      }

      const isGenericHTML = version.path.endsWith('index.html');

      if (isGenericHTML) {
        return true;
      }

      const isLanguageMatchHTML = version.path.endsWith("index.".concat(language.name.toLowerCase(), ".html"));

      if (isLanguageMatchHTML) {
        return true;
      }

      return false;
      /* Is HTML but is a language version (index.$LANGCODE.html) & doesn't match #language */
    })
  }));
  const properties = {
    data: {
      download: {
        language: language.flatten(),
        tour: tour.flatten(),
        site: site.flatten(),
        media: JSON.stringify(propertiesMediaJSON),
        downloadList: downloadList.map(item => item.flatten())
      },
      session: {
        apiUrl: settings(environment).authUrl,
        name: settings(environment).authUsername,
        password: settings(environment).authPassword
      }
    },
    tour: {
      model: model,
      type: ITourType.Hamburger
    },
    localizedHeadData
  };
  /* Cannot serialize undefined or function value types */

  changeValueByTypes(properties, ['undefined', 'function'], null);
  return {
    props: properties
  };
};

function TourView(_ref2) {
  let {
    tour: {
      model,
      type
    },
    localizedHeadData,
    data
  } = _ref2;
  const router = useRouter();
  const onBack = useCallback(() => {
    router.back();
  }, [router]);
  useEffect(() => {
    const site = injectModelInstantiator().instantiate('ISiteDto', data.download.site);
    siteData.insert('ISiteDto', site);
    const language = injectModelInstantiator().instantiate('ILanguageDto', data.download.language);
    siteData.insert('ILanguageDto', language);
    const tour = injectModelInstantiator().instantiate('ITourDto', data.download.tour);
    siteData.insert('ITourDto', tour);
    const media = data.download.downloadList.map(medium => injectModelInstantiator().instantiate('IMediumDto', medium));
    siteData.insert('IMediumDto', media);
    const mediaSpec = streamlibMedia.expand(data.download.media);
    resolverData.mediaPrefix = '/assets';
    resolverData.downloadList = media;

    if (mediaSpec) {
      resolverData.mediaSchema = mediaSpec;
      const publicUrl = injectSiteConfig().public_url;
      const publicPrefix = publicUrl ? new URL(publicUrl).href : '';
      const cacheController = injectMediaCacheController(container);
      cacheController.addCacheResolver('app-assets-local-cache', mediaId => {
        const matchingItems = mediaSpec.media.filter(item => item.sourceGuid === mediaId);
        const urls = matchingItems.flatMap(item => item.versions.flatMap(version => {
          var _version$dependencies;

          return ((_version$dependencies = version.dependencies) !== null && _version$dependencies !== void 0 ? _version$dependencies : [version]).map(version =>
          /* E.g. will generate https://www.atsweb.app/c/demo/assets/1234/master.avif */
          [publicPrefix, resolverData.mediaPrefix, version.path].map(path => path === null || path === void 0 ? void 0 : path.replace(/^\//, '')).join('/').replace(/^/, '/'));
        }));
        return urls;
      });
    }

    const sessionInstantiator = injectAPISession();
    sessionInstantiator.open(data.session.name, {
      apiUrl: data.session.apiUrl,
      apiUsername: data.session.name,
      apiPassword: data.session.password
    }).then(activeSession => {
      sessionInstantiator.setActive(activeSession); // TEMPORARY, TODO - remove

      activeSession.save().catch(error => {
        throw error;
      });
      activeSession.state.setProperty(IUserProperties.LanguageId, data.download.language.id);
      activeSession.state.setProperty(IUserProperties.TourId, data.download.tour.id);
    }).catch(error => {
      throw error;
    });
  }, [data]);
  const {
    0: downloadTour,
    1: setDownloadTour
  } = useState(undefined);
  const {
    0: deleteTour,
    1: setDeleteTour
  } = useState(undefined);
  useEffect(() => {
    if (type === ITourType.Hamburger) {
      import('@monofe/ui-workspace/download-tour').then(module => {
        setDownloadTour(module.injectDownloadTour());
      }).catch(error => {
        throw error;
      });
    } else {
      import('@monofe/ui-workspace/download-language').then(module => {
        setDownloadTour(module.injectDownloadLanguage());
      }).catch(error => {
        throw error;
      });
    }

    import('@monofe/ui-workspace/delete-tour').then(module => {
      setDeleteTour(module.injectDeleteTour());
    }).catch(error => {
      throw error;
    });
  }, [type]);
  const {
    0: viewModelState,
    1: viewModelDispatcher
  } = useReducer(_StateReducer, _objectSpread(_objectSpread({}, model), {}, {
    type,
    showPopUpDownload: true,
    showPopUpDelete: false
  }));
  const reducer = useCallback(modifier => {
    viewModelDispatcher(modelState => _objectSpread({
      type: modelState.type,
      showPopUpDownload: modelState.showPopUpDownload,
      showPopUpDelete: modelState.showPopUpDelete
    }, getProjectOverrides('ITourMainProps', modifier(modelState))));
  }, [viewModelDispatcher]);
  const onDownloadStatusRequest = useCallback(newStatus => {
    if (!downloadTour || !deleteTour) {
      return;
    }

    if (newStatus && downloadTour.isShowable()) {
      deleteTour.hide();
      downloadTour.show();
    } else if (!newStatus && deleteTour.isShowable()) {
      downloadTour.hide();
      deleteTour.show();
    } else {
      return;
    }

    reducer(oldState => _objectSpread(_objectSpread({}, oldState), {}, {
      hasContentDownloaded: newStatus
    }));
  }, [downloadTour, deleteTour, reducer]);
  useEffect(() => {
    const viewModel = _objectSpread(_objectSpread({}, model), {}, {
      onBack,
      onDownloadStatusRequest
    });

    reducer(modelIn => _objectSpread(_objectSpread(_objectSpread({}, modelIn), viewModel), {}, {
      type
    }));
  }, [model, onBack, onDownloadStatusRequest, reducer, type]);
  useEffect(() => {
    reducer(oldState => _objectSpread(_objectSpread({}, oldState), {}, {
      onDownloadStatusRequest
    }));
  }, [reducer, onDownloadStatusRequest]);
  return __jsx(React.Fragment, null, __jsx(Head, null, localizedHeadData.map(data => __jsx("link", {
    key: data.url,
    rel: "alternate",
    hrefLang: data.languageCode.toLowerCase(),
    href: data.url
  })), viewModelState.backgroundImage.urls.filter(url => Boolean(url.src)).slice(0, 1).map(url => __jsx("link", {
    key: url.src,
    rel: "preload",
    as: "image",
    type: url.type,
    href: url.src
  })), viewModelState.collection.items.slice(0, 4).flatMap(item => item.backgroundImage.urls.slice(0, 1)).filter(url => Boolean(url.src)).map(url => __jsx("link", {
    key: url.src,
    rel: "preload",
    as: "image",
    type: url.type,
    href: url.src
  })), __jsx("title", null, viewModelState.topBar.title.text)), downloadTour && __jsx(downloadTour.renderer, null), type === ITourType.Hamburger && __jsx(DownloadTourAlertTrigger, viewModelState), type === ITourType.List && __jsx(DownloadLanguageAlertTrigger, viewModelState), __jsx(MainView, {
    key: "Tour",
    type: viewModelState.type,
    model: viewModelState
  }));
}

export default TourView;